export default {
  hoursAgo: 't siden'
};
